'use client';

import { useRouter } from 'next/navigation';
import { useCallback, useMemo } from 'react';
import { createOfferBundleActionHandlers, type OfferActionDeps } from '../helpers/offerBundleActions';

type UseOfferBundleActionHandlersOptions = Pick<OfferActionDeps, 'refetch' | 'openDepositSheet' | 'scratchcards'>;

function useOfferBundleActionHandlers(options: UseOfferBundleActionHandlersOptions = {}) {
  const { refetch, openDepositSheet, scratchcards = [] } = options;
  const router = useRouter();

  const navigate = useCallback(
    (url: string) => {
      router.push(url);
    },
    [router]
  );

  return useMemo(() => createOfferBundleActionHandlers({ navigate, refetch, openDepositSheet, scratchcards }), [navigate, refetch, openDepositSheet, scratchcards]);
}

export { useOfferBundleActionHandlers, type UseOfferBundleActionHandlersOptions };
